import React, { Component } from "react";
import {
  Button,
  Table,
  Row,
  Badge,
} from "reactstrap";
import Select from 'react-select'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Moment from 'react-moment';
import moment from 'moment';
import 'moment-timezone';
import { reduxForm, Field } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import Pagination from "react-js-pagination";
import { contractsListRequest, contractsUpdateRequest } from './actions'
import { CONTRACTS_LIST_SUCCESS } from './constants'
import { storedb } from '../../views/client/storedb'
import * as contractAction from './actions'
import Collapsible from 'react-collapsible';
import DisplayRecordText from "../controls/_DisplayRecordText"

class Contracts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalUpdatecontracts: false,
      item: {},
      list: [],
      TrangThaiId: 0,
      LoaiId: 0,
      NhanVienId: 0,
      TuNgay: moment().add(-1, 'years'),
      DenNgay: moment().add(1, 'years'),
      keyword: '',
      per_page: 20,
      page: 1,
    };
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }
  handleDateChange(name, e, value) {
    switch (name) {
      case "TuNgay":
        this.setState({ TuNgay: e });
        break;
      case "DenNgay":
        this.setState({ DenNgay: e });
        break;
    }
  }
  handleSearchChange(name, e, value) {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleSelectChange = (name, selectedOption) => {
    switch (name) {
      case "TrangThai":
        this.setState({ TrangThaiId: selectedOption.target.value })
        break;
      case "Loai":
        this.setState({ LoaiId: selectedOption.target.value })
        break;
      case "NhanVien":
        this.setState({ NhanVienId: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  featchLoaiHopDong = () => {
    const { contractsLoaiRequest } = this.props;
    return contractsLoaiRequest();
  }
  featchTrangThaiHopDong = () => {
    const { contractsTrangThaiRequest } = this.props;
    return contractsTrangThaiRequest();
  }
  featchNhanVien = () => {
    const { contractsNhanVienRequest } = this.props;
    return contractsNhanVienRequest();
  }
  fetchList = () => {
    const { contractsListRequest } = this.props

    var requestData = {
      keyword: this.state.keyword,
      tuNgay: this.state.TuNgay.format("YYYY-MM-DD"),
      denNgay: this.state.DenNgay.format("YYYY-MM-DD"),
      loaiId: this.state.LoaiId,
      trang_thai: this.state.TrangThaiId,
      nhan_vien: this.state.NhanVienId,
      page: this.state.page,
      per_page: this.state.per_page
    };
    return contractsListRequest(requestData);
  }
  search = () => {
    if (this.props.contracts.listRequesting) {
      return false;
    }
    return this.fetchList()
  }
  EditContractItem = (item, e) => {
    e.preventDefault();
    this.props.history.push('/chi-tiet-hop-dong?contract=' + (item.ContractId || ""));
  }
  componentDidMount() {
    this.featchLoaiHopDong();
    this.featchTrangThaiHopDong();
    this.featchNhanVien();
    this.fetchList();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.contracts.type == CONTRACTS_LIST_SUCCESS) {
      let { list, item } = nextProps.contracts;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        total_record: item.total_record,
        list: list
      });
    }
  }
  render() {
    const { list } = this.state
    const {
      handleSubmit,
      contracts: {
        listLoaiHD,
        listTrangThaiHD,
        listNhanVien,
        listRequesting
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <div>
          <Collapsible trigger="Tìm kiếm..." open={true}>
            <Row className="mb-1">
              <div className="col-sm-4 mb-2">
                <Field type="text" autoComplete="off" name="keyword" placeholder="Số hợp đồng, tên hợp đồng, tên khách hàng, điện thoại" className={"form-control"} onChange={this.handleSearchChange.bind(this, "keyword")} component="input" />
              </div>
              <div className="col-sm-1 mb-2">
                <DatePicker name="TuNgay" placeholder="Từ ngày" selected={this.state.TuNgay} onChange={this.handleDateChange.bind(this, "TuNgay")} required className={"form-control"} />
              </div>
              <div className="col-sm-1  mb-2">
                <DatePicker name="DenNgay" placeholder="Đến ngày" selected={this.state.DenNgay} onChange={this.handleDateChange.bind(this, "DenNgay")} required className={"form-control"} />
              </div>
              <div className="col-sm-2  mb-2">
                <select placeholder="Nhân viên phụ trách" name="NhanVien" className={"form-control"} onChange={this.handleSelectChange.bind(this, "NhanVien")}
                  value={this.state.item.NhanVienId}>
                  <option value={0} key={0}>--Nhân viên--</option>
                  {listNhanVien.map(option => {
                    return (
                      <option value={option.id} key={option.id}> {option.Ten}</option>
                    )
                  })
                  }
                </select>
              </div>
              <div className="col-sm-2  mb-2">
                <select placeholder="Nhân viên phụ trách" name="Loai" className={"form-control"} onChange={this.handleSelectChange.bind(this, "Loai")}
                  value={this.state.item.LoaiId}>
                  <option value={0} key={0}>--Loại hợp đồng--</option>
                  {listLoaiHD.map(option => {
                    return (
                      <option value={option.id} key={option.id}> {option.Ten}</option>
                    )
                  })
                  }
                </select>
              </div>
              <div className="col-sm-2  mb-2">
                <select name="TrangThai" className={"form-control"} onChange={this.handleSelectChange.bind(this, "TrangThai")}
                  value={this.state.item.TrangThaiId}>
                  <option value={0} key={0}>--Trạng thái hợp đồng--</option>
                  {listTrangThaiHD.map(option => {
                    return (
                      <option value={option.id} key={option.id}> {option.Ten}</option>
                    )
                  })
                  }
                </select>
              </div>
            </Row>
          </Collapsible>
        </div>
        <div className="mt-2 bg-white">
          <div className="w-100 mb-2">
            <Button className="btn btn-success" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i>&nbsp;Tìm kiếm</Button>&nbsp;
            <Button color="primary" onClick={this.EditContractItem.bind(this, {})}><i className="fa fa-plus"></i>&nbsp;Thêm mới</Button>
          </div>
        </div>
        <BlockUi tag="div" blocking={listRequesting} >
          <div className="w-100">
            <DisplayRecordText
              itemsCountPerPage={this.state.per_page}
              onChangeItem={this.onChangeItem}
            />
            <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
              <thead className="thead-default">
                <tr>
                  <th scope="col" width="70" className="text-center">#</th>
                  <th scope="col" width="150" className="text-left">Ngày ký</th>
                  <th scope="col" width="150" className="text-left">Ngày hiệu lực</th>
                  <th scope="col" width="150" className="text-left">Ngày hết hạn</th>
                  <th scope="col" width="150" className="text-left">Số hợp đồng</th>
                  <th scope="col" className="text-left">Tên hợp đồng</th>
                  <th scope="col" width="150" className="text-left">Tên khách hàng</th>
                  <th scope="col" width="150" className="text-left">Điện thoại</th>
                  <th scope="col" width="150" className="text-left">Loại hợp đồng</th>
                  <th scope="col" width="100" className="text-center">Trạng thái</th>
                  <th scope="col" width="20" className="text-center">Sửa</th>
                </tr>
              </thead>
              <tbody>
                {list && !!list.length && (
                  list.map((res, idx) => (
                    <tr key={idx + 1}>
                      <td className="text-center">{idx + 1}</td>
                      <td className="text-left">{res.NgayKy ? <Moment format="DD/MM/YYYY">{`${res.NgayKy}`}</Moment> : null}</td>
                      <td className="text-left">{res.TuNgay ? <Moment format="DD/MM/YYYY">{`${res.TuNgay}`}</Moment> : null}</td>
                      <td className="text-left">{res.DenNgay ? <Moment format="DD/MM/YYYY">{`${res.DenNgay}`}</Moment> : null}</td>
                      <td className="text-left">{res.SoHopDong}</td>
                      <td className="text-left">{res.TenHopDong}</td>
                      <td className="text-left">{res.TenKhachHang}</td>
                      <td className="text-left">{res.DienThoai}</td>
                      <td className="text-left">{res.LoaiHD}</td>
                      <td className="text-center">
                        {res.TrangThaiId == 2 ? <Badge color="success">{res.TrangThaiHD}</Badge> : <Badge color="warning">{res.TrangThaiHD}</Badge>}
                      </td>
                      <td scope="row" className="text-center">
                        <Button color="primary" className="btn-sm" onClick={this.EditContractItem.bind(this, res)}><i className="fa fa-pencil"></i></Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
            {this.state.total_record > this.state.per_page && (
              <Pagination
                activePage={this.state.page}
                itemsCountPerPage={this.state.per_page}
                totalItemsCount={this.state.total_record}
                pageRangeDisplayed={5}
                onChange={this.handlePageChange}
              />
            )}
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  contracts: state.contracts,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  contractsListRequest: contractAction.contractsListRequest,
  contractsUpdateRequest: contractAction.contractsUpdateRequest,
  contractsLoaiRequest: contractAction.contractsLoaiRequest,
  contractsTrangThaiRequest: contractAction.contractsTrangThaiRequest,
  contractsNhanVienRequest: contractAction.contractsNhanVienRequest
})(Contracts)

const formed = reduxForm({
  form: 'contracts',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Contracts/Contracts.js